let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

var id = getUrlParameter('id'), f_name = "", C_number = "", C_email = "", user__gender = "", user_gender = "", rid = "", caseId = "", selectedStage = 'Stage-1';
var cohort = getUrlParameter('cohort'), variantsID = 0, recommended_products = [], variantsIDs = [];
var prices = 0, doc__fee = 100000, diet__plan = 50000, hair__coach_fee = 50000, month1_total, month1DiscountPrice, month3DiscountPrice, month6DiscountPrice, discount_pricetext = 0;
let successfulFetchCount = 0, totalProducts = 0;
if (id) {
  localStorage.setItem('user-gender', 'male');
  localStorage.setItem('rid', id);
}
id = localStorage.getItem('rid');
if(id === undefined) {
  id = getCookie('syntheticId');
}
(function () {
  if(!id) {
    if(window.location.pathname == '/pages/result4'){
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href= 'https://ae-form.traya.health/questions?cohort=1&source=ResultPage'
    }
    var data_formPage = document.querySelectorAll('[data-formPage]'),
      data_resultPage = document.querySelectorAll('[data-resultPage]'),
      data_resultbtn = document.querySelectorAll('[data-resultbtn]'),
      data_notResult = document.querySelectorAll('[data-notResult]');
    if(data_formPage.length != 0) {
      data_formPage.forEach((formpage) => { formpage.style.display = "block"; });
    }
    if(data_resultPage.length != 0) {
      data_resultPage.forEach((resultpage) => { resultpage.style.display = "none"; });
    }
    if(data_resultbtn.length != 0) {
      data_resultbtn.forEach((resultbtn) => { resultbtn.style.display = "none"; });
    }
    if(data_notResult.length != 0) {
      data_notResult.forEach((notresult) => { notresult.style.display = "block"; });
    }
  }else {
    setotherCookie('syntheticId', id, 30, '.traya.health');
    var data_result = document.querySelectorAll('[data-result]');
    if(data_result.length != 0) {
      data_result.forEach((result) => { result.style.display = "block"; })
    }
  }
  var baseUrls = {
    DEV: 'https://api-gateway-thnu3-ae.hav-g.in/',
    PROD: 'https://api.hav-g.in/'
  };
  
  var tokens = {
    DEV: {
      'x-tenant-id': 'trayauae',
      'x-access-token': '974536e0-3f0c-4632-b1e4-c6a4c46b7c4f'
    },
    PROD: {
      'x-tenant-id': 'trayauae',
      'x-access-token': 'd7ef603e-71ea-44a1-93f2-2bacd08c4a90'
    }
  };
  
  var token = tokens.DEV;
  var baseUrl = baseUrls.DEV;
  
  var liveendpoint = `${baseUrl}consumer-api/service/recommendations-uae/dgReport/hair-test-report-v2/`;
  window.addEventListener('DOMContentLoaded', function() {
    clearCart();
    var atcButton = document.querySelectorAll('#add-to-cart-result-page');
    if(atcButton.length != 0) {
      atcButton.forEach((button) => {
        button.addEventListener('click', function() {
          // button.setAttribute('disabled', true);
          // button.innerText = 'Initiating Checkout...';
          fetch('/cart/clear.js', {
            method: "POST",
            headers: {
              'Content-Type': 'application/json'
            }
          }).then((response) => {
            return response.json();
          }).catch((error) => {
            console.error('Error: ', error);
          }).finally(() => {
            checkout();
          })
        })
      });
    }
    getMaleResult(liveendpoint, id, token);
  })
})();

var clearCart = function() {
  var formdata = {
    sections: 'cart-drawer'
  };
  fetch('/cart/clear.js', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formdata)
  }).then((response) => {
    return response.json();
  }).then((result) => {
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer, drawer=false,0);
  }).catch((error) => {
    console.error('Error: ', error);
  })
}

function getMaleResult(livepoint, id, token) {
  document.body.style.overflow = 'hidden';
  window.location.href = `/pages/result4b?id=${id}`;
  fetch(`${livepoint}${id}`, {
    headers: token
  }).then((response) => {
    return response.json();
  }).then((response) => {
    ShowContent(response);
    rootCause(response?.root_causes);
    resultMonthKit(response);
    displayProduct(response);
    // customPriceSection(response);
    sectionMonthsExpectetion(response);
    sectionRealStories(response);
  }).catch((error) => {
    console.error('Error: ', error);
    document.body.style.overflow = 'unset';
  });
}

// custom price 
function customPriceSection(response) {
  let cartPrice = response.cart_price;
  cartPrice = parseFloat(cartPrice).toFixed(2);
    if (cartPrice.endsWith('.00')) {
      cartPrice = parseInt(cartPrice);
    }

  const dynamicPriceElements = document.querySelectorAll('#dynamic-price');
  if (dynamicPriceElements.length > 0) {
    dynamicPriceElements.forEach(element => {
      element.innerHTML = cartPrice;
    });
  } else {
    console.error('Price elements not found');
  }
}
// end of custom price

// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');
    const weeksUpdateElement = document.querySelector('.weeks-update')
    weeksUpdateElement.innerHTML = monthsExpectation.months;
    monthsExpectation.monthExpectations.forEach((month, index) => {
        const block = document.createElement('div');
        block.className = 'timeline-block';
        block.innerHTML = `
            <div class="timeline-icon">
              <img src="${month.image_url}" alt="Month ${month.month}">
            </div>
            ${index < monthsExpectation.monthExpectations.length - 0 ? `
              <div class="timeline-dot-line">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>
            ` : ''}
            <div class="timeline-content">
              <p><strong>Month ${month.month}</strong></p>
              <p>${month.goal}</p>
            </div>
        `;
       timeline.appendChild(block);
    });
    if(window.innerWidth > 767){
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              centerPadding: "15px",
            },
          },
        ],
      });
    }
  }
}

// functionality for real stories
function sectionRealStories(response) {
  let { successStories } = response;
  if (successStories.showComponent == true) {
    const imgCarousel = document.querySelector('.image-carousel');
    const titleElement = document.querySelector('.stories-main-heading');
    const subTitleElement = document.querySelector('.stories-sub-heading');

    // Set title and subtitle
    titleElement.textContent = successStories.title;
    subTitleElement.textContent = successStories.subTitle;

    // Loop through each story to create image elements
    successStories.stories.forEach((storyUrl) => {
      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl.imageUrl}" alt="Success Story" height="auto" width="auto">
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    // Initialize the Slick carousel after appending elements
    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true, 
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            dots: true,
          },
        },
      ],
    });
  }
}
// Function to create and display popup with product details
function createProductPopup(productId) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: { 
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: { 
      "Link": "uae-formv2s.dev.hav-g.in"
    }
  };

  const iframeUrl = `https://${siteUrl.prod.Link}/product-drawerv2/${productId}`;
  
  // Load external product detail page into popup content placeholder
  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;
  
  if (isMobileDevice()) {
    // Mobile view: popup from the bottom
    popup.style.bottom = '0';
  } else {
    // Desktop view: popup from the right
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // Close popup when close icon is clicked
  const closeIcon = document.getElementById('close-popup');
  closeIcon.addEventListener('click', function() {
    closeProductPopup();
  });

  // Close popup when overlay is clicked
  overlay.addEventListener('click', function() {
    closeProductPopup();
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = '';
} 

// Function to create and show the popup
function showProductPopup(productId,language) {
  let popup = document.querySelector('.product-popup');
  let prodId = document.querySelector('[data-product-id]').getAttribute('data-product-id');
  console.log(prodId)

  // Create the popup if it doesn't exist
  if (!popup) {
    popup = document.createElement('div');
    popup.classList.add('product-popup');
    
    popup.innerHTML = `
      <div class="popup-content">
        <span class="close-btn">&times;</span>
        <iframe class="popup-iframe" src="" frameborder="0"></iframe>
      </div>
    `;
    document.body.appendChild(popup);

    // Add event listener to the close button
    popup.querySelector('.close-btn').addEventListener('click', () => {
      popup.classList.remove('show');
      document.body.style.overflow = '';
      document.querySelector('.empty-div').style.display = "none";
    });
  }
 
  // Set the iframe source and show the popup
  const iframe = popup.querySelector('.popup-iframe');
  iframe.src = `https://ae-form.traya.health/product-drawerv2/${productId}`;
  popup.classList.add('show');
  document.body.style.overflow = 'hidden';
  document.querySelector('.empty-div').style.display = "flex";
}

// Function to add click event listener to month kit product cards
function addClickEventListernerToMonthkit() {
  document.querySelectorAll('.shopify-kit-section .kit-card').forEach((kit) => {
    kit.addEventListener('click', function (event) {
      const productId = event.currentTarget.getAttribute('data-product-id');
      const language = 'english'; 
      showProductPopup(productId);
    });
  });
}

function displayProduct(response) {
  var resp = Object.assign(response.User_Analysis, response.Recommendations);
  f_name = resp.first_name;
  C_number = resp.phone;
  C_email = resp.email;
  user__gender = resp.gender;
  setCookie('user_phone', C_number, 30);
  caseId= resp.case_id;
  localStorage.setItem('caseId', caseId);
  if(user__gender == 'M') {
    user_gender = 'Male';
  }
  var coin_size = false;
  if(resp.stage == 'Coin Size Patch') {
    coin_size = true;
  }
  var productTemplate = 'result-product-list', slides = 1, mobileSlides = 1 ,arrows = false, dots = true;
  if(resp.stage == "Stage-1") {
    productTemplate = 'result4c-card', slides = 3, mobileSlides = 1.3;
  }else {
    productTemplate = 'result4c-card', slides = 3, mobileSlides = 1.3;
    // productTemplate = 'result-product-list', slides = 1, mobileSlides = 1;
  }
  var test_result = document.querySelectorAll('.test-result'), sticky_btn = document.querySelectorAll('.sticky-btn'), 
  transplant_stage_six = document.querySelectorAll('.transplant-stage-six'), normal_page_is = true;
  var  stageDescription_text = document.querySelectorAll('.stageDescription_text'),
  user_type_stage = document.querySelectorAll('.user_type_stage'), diagnosed_text = document.querySelectorAll('.diagnosed_text'),
  productKitSection = document.querySelectorAll('.kit-container'), doctorsSection = document.querySelectorAll('.section-coach.container'),
  timelineSection = document.querySelectorAll('.timeline--container'), priceBreakStage = document.querySelectorAll('.custom-price-section'),
  eligibilityCheck = document.querySelectorAll('.eligibility-check--section'), faqSection = document.querySelectorAll('.aldrich-faq');
  if(resp.gender == 'M' && resp.stage == "Stage-6"){
    document.querySelector('body.result4').style.width = '100%';
    document.querySelector('body.result4 #MainContent').style.padding = 0;
    normal_page_is = false;
  }else{
    normal_page_is = true;
  }
  if(test_result.length != 0) {
    test_result.forEach((result) => {
      if(normal_page_is == false) {
        result.classList.add('d-none');
      }else {
        result.classList.remove('d-none');
      }
    })
  }
  if(productKitSection.length != 0) {
    productKitSection.forEach((kit) => {
      if(normal_page_is == false) {
        kit.classList.add('d-none');
      }else {
        kit.classList.remove('d-none');
      }
    })
  }
  if(doctorsSection.length != 0) {
    doctorsSection.forEach((doctors) => {
      if(normal_page_is == false) {
        doctors.classList.add('d-none');
      }else {
        doctors.classList.remove('d-none');
      }
    })
  }
  if(timelineSection.length != 0) {
    timelineSection.forEach((time) => {
      if(normal_page_is == false) {
        time.classList.add('d-none');
      }else {
        time.classList.remove('d-none');
      }
    })
  }
  if(priceBreakStage.length != 0) {
    priceBreakStage.forEach((priceBreak) => {
      if(normal_page_is == false) {
        priceBreak.classList.add('d-none');
      }else {
        priceBreak.classList.remove('d-none');
      }
    })
  }
  if(eligibilityCheck.length != 0) {
    eligibilityCheck.forEach((check) => {
      if(normal_page_is == false) {
        check.classList.add('d-none');
      }else {
        check.classList.remove('d-none');
      }
    })
  }
  if(faqSection.length != 0) {
    faqSection.forEach((faq) => {
      if(normal_page_is == false) {
        faq.classList.add('d-none');
      }else {
        faq.classList.remove('d-none');
      }
    })
  }
  if(sticky_btn.length != 0) {
    sticky_btn.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.add('d-none');
      }else {
        section.classList.remove('d-none');
      }
    });
  }
  if(transplant_stage_six.length != 0) {
    transplant_stage_six.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.remove('d-none');
      }else {
        section.remove();
      }
    });
  }
    
  // Recommended Products End
  if (resp.stage == "Stage-1") {
    document.querySelector('#stage').innerHTML = 'Stage 1 Of ';
  }else if (resp.stage == "Stage-2") {
    document.querySelector('#stage').innerHTML = 'Stage 2 Of ';
  }else if(resp.stage == "Stage-3"){
    document.querySelector('#stage').innerHTML = 'Stage 3 Of ';
  }else if(resp.stage == "Stage-4"){
    document.querySelector('#stage').innerHTML = 'Stage 4 Of ';
  }else if(resp.stage == "Stage-5"){
    document.querySelector('#stage').innerHTML = 'Stage 5 Of ';
  }
  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }
  document.body.style.overflow = 'unset';
}

function rootCause (response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];
  let primaryRootCauseHtml = '';
  let primaryRootCauseContentHtml = '';
  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" />
        </div>
         <p class="mt-2">${primaryRootCause[0]?.title}</p>
      </a>
    </li>`;
  }
  if (primaryRootCause.length > 0) {
    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }
  const defaultRootCauseHtml = defaultRootCause.map((item) => {
    return `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
        <div class="rootCauseLinkImg">
          <img src="${item?.details?.icon}" />
        </div>
        <p class="mt-2">${item?.title}</p>
      </a>
    </li>`;
  }).join('');
  const defaultRootCauseContentHtml = defaultRootCause.map((item) => {
    return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${item?.details?.description?.english}</p></div>`;
  }).join('');
  const rootCauseHtml = `<ul class="nav rootCause-nav-tabs border-0" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>
  <div class="tab-content rootCauseTabContent p-2 p-md-3 mt-3" id="myTabContent">${primaryRootCauseContentHtml}${defaultRootCauseContentHtml}</div>`;
  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
  }
}

function InitProductSlider(slides, mobileSlides) {
  $('.result_product_slides').slick({
    slidesToShow: slides,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: mobileSlides,
          slidesToScroll: 1,
          infinite: false,
          arrows: false
        }
      }
    ]
  });
}

// Function to create the month kit section
function resultMonthKit(response) {
    const productData = response.product_Ids;
    const priceCart = response.cart_price
    
  
    // Create the container div
    const containerDiv = document.createElement('div');
    containerDiv.classList.add('kit-container', 'container');
  
    // Create the header and add it to the container
    const header = document.createElement('h2');
    header.classList.add('kit-header', 'section-heading-font');
    header.innerText = 'Your 1st Month Kit';
    containerDiv.appendChild(header);
  
    if(window.innerWidth <= 767){
      containerDiv.classList.remove('container');
    }
    // Create the section and add it to the container
    const newSection = document.createElement('section');
    newSection.classList.add('shopify-kit-section');
  
    // Add the product data to the section
    productData.forEach((each) => {
      const productDiv = document.createElement('div');
      productDiv.classList.add('kit-card');
      productDiv.dataset.productId = each.product_id;
      
      const conversionRate = 23.59; // Example: USD to AED conversion rate
      let moneyPrice = theme.Currency.formatMoney(each.price, theme.moneyFormat);
      productDiv.innerHTML = `
        <div class="product-imge">
          <img src="${each.image_url.singleImage}" /> 
        </div>
        <div class="product-description">
          <div class="prod-heading">
            <p class="prod-title">${each.name}</p>
            <div class="tags">
              <img src="${each.tag.icon}" />
              <p class="tag-title">${each.tag.title}</p>
            </div>
          </div>
          <div>
            <p class="prod-details">${each.oneLiner}</p>
          </div>
          <div>
           <p class="prod-price">
              ${each.price} AED
          </p>
          </div>
        </div>
        <div class="arrow">    
          <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.53255 7.03063L1.53255 12.0306C1.39165 12.1715 1.20056 12.2507 1.0013 12.2507C0.802043 12.2507 0.610947 12.1715 0.470051 12.0306C0.329155 11.8897 0.25 11.6986 0.25 11.4994C0.25 11.3001 0.329155 11.109 0.470051 10.9681L4.93943 6.5L0.471301 2.03063C0.401536 1.96086 0.346196 1.87804 0.308439 1.78689C0.270683 1.69574 0.25125 1.59804 0.25125 1.49938C0.25125 1.40072 0.270683 1.30302 0.308439 1.21187C0.346196 1.12072 0.401536 1.03789 0.471301 0.968128C0.541066 0.898364 0.623889 0.843023 0.715041 0.805267C0.806193 0.76751 0.903889 0.748077 1.00255 0.748077C1.10121 0.748077 1.19891 0.76751 1.29006 0.805267C1.38121 0.843023 1.46404 0.898364 1.5338 0.968128L6.5338 5.96813C6.60364 6.03789 6.65902 6.12075 6.69677 6.21196C6.73451 6.30316 6.75388 6.40093 6.75377 6.49964C6.75365 6.59835 6.73405 6.69606 6.69609 6.78718C6.65813 6.8783 6.60255 6.96103 6.53255 7.03063Z" fill="black" />
          </svg>
        </div>
      `;
      newSection.appendChild(productDiv);
      if(getCookie("GuestForm_id")){
        variantsIDs.push({
          'id': each.product_id,
          'quantity': 1,
          properties: {
            '_result_id': id
          }
        });
      }else{
        variantsIDs.push({
          'id': each.product_id,
          'quantity': 1
        });
      }
    });
    
    // Append the section to the container
    containerDiv.appendChild(newSection);
  
    // Insert the container into the DOM
    const firstSection = document.querySelectorAll('main .ss.test-result')[0];
    if (firstSection && firstSection.parentNode) {
      firstSection.parentNode.insertBefore(containerDiv, firstSection.nextSibling);
    }
  
    // Add click event listeners to the product cards
    addClickEventListernerToMonthkit();
}

function getProductByHandle(response) {
  let resultTotalPrice = document.querySelectorAll('.total-price');
  const finalCartPrice = response.cart_price;
  
  if (resultTotalPrice.length !== 0) {
    resultTotalPrice.forEach((price) => {
      price.innerHTML = `<del>${(parseInt(finalCartPrice) + 70)} AED</del> ${finalCartPrice} AED`;
    });
  }
}

function checkout() {
  localStorage.setItem('user__gender',user_gender);
  localStorage.setItem('caseId',caseId);
  variantsIDs.forEach((e) => {
    if(e.id === 37681124081842){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 42648509186226){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 41899898011826){
      e.properties = {'Plan': 'Dandruff'};
    }else {
      e.properties = {'Plan': 'Auto'};
    }
  });
  let formData = {
    'items': variantsIDs,
    sections: 'cart-drawer',
    attributes: {
      first_name: f_name,
      phone: C_number,
      email: C_email
    }
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {  
    localStorage.setItem('User_location', "cart");
    return response.json();
  }).then(result => { 
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer);
  }).catch((error) => {
    console.error('Error:', error);
  }).finally(() => {
    cartData();
  });
}

function ShowContent(response) {
  getProductByHandle(response);
  var data = Object.assign(response.User_Analysis, response.Recommendations);
  let stageDescription = response.stageWiseDescription.english;
  var growthPossibility = response.growthPossibilityBar;
  var maxMonth = response.Recommendations.Max_months;
  var grothBar = document.querySelector(".cstm-growthPossibilityBar")
  var treatedCount = response.treatedCXCount.description;
  var treatedCountDOM = document.querySelector(".customer-based-profile");
  var treatmentDuration = document.querySelector(".traetment-duration");
  treatmentDuration.innerText = `${maxMonth} Months`
  treatedCountDOM.innerText = treatedCount;
  var illness = data.experienced_in_one_year, genetics = data.Genetic, userStage = data.stage;
  var userName = document.querySelectorAll('[data-user-name]'), name1 = document.querySelectorAll('#name1'),
  name3 = document.querySelectorAll('#name3'), stage1 = document.querySelectorAll('#stage1'),
  typeOfLoss3 = document.querySelectorAll('#typeOfLoss3'), stage3 = document.querySelectorAll('#stage3'),
  stageDescriptionMain = document.querySelectorAll('#stageDescription'), stage3 = document.querySelectorAll('#stage3'),
  typeOfLoss = document.querySelectorAll('#typeOfLoss'), mainstage = document.querySelectorAll('#stage');
  var ourdia = document.querySelector('#ourdia'), stagesnames = document.querySelectorAll('.stages-name');
  var stageImage = response?.currentStage?.imgUrl;
  if(growthPossibility == true){grothBar.style.display = "block";}
  if(userName.length != 0) { userName.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(name1.length != 0) { name1.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(name3.length != 0) { name3.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(stage1.length != 0) { stage1.forEach((stage) => { stage.innerHTML = `${data.stage?.replace(/-/g, ' ')}` }) }
  if(typeOfLoss3.length != 0) { typeOfLoss3.forEach((loss) => { loss.innerHTML = `${data.Type_of_hair_loss}` }) }
  if(stage3.length != 0) { stage3.forEach((stage) => { stage.innerHTML = `${data.stage?.replace(/-/g, ' ')}` }) }
  if(stageDescriptionMain.length != 0) { 
    stageDescriptionMain.forEach((stage) => { 
      stage.innerHTML = `${stageDescription}`; 
    })
  }
  if(illness.length != 0) {
    var TECondition = illness.filter((ill) => {
      if(ill == 'Severe Illness (Dengue, Malaria, Typhoid or Covid)') {
        return ill;
      }
    })
    if(TECondition.length == 1 && (genetics == 'Yes' || genetics == 'No') && (userStage == 'Heavy Hair Fall Across The Head' || userStage == 'Heavy Hair Fall')) {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Telogen Effluvium`; }) }
      // if(mainstage.length != 0) { mainstage.forEach((stage) => { stage.innerHTML = `${data.stage.replace(/-/g, ' ')}` }) }
    }else if(TECondition.length == 0 && genetics == 'Yes' && (userStage == 'Heavy Hair Fall Across The Head' || userStage == 'Heavy Hair Fall')) {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Male Pattern Hair Loss`; }) }
    }else if(TECondition.length == 0 && genetics == 'No' && (userStage == 'Heavy Hair Fall Across The Head' || userStage == 'Heavy Hair Fall')) {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Telogen Effluvium`; }) }
      if(mainstage.length != 0) { mainstage.forEach((stage) => { stage.innerHTML = `${data.stage.replace(/-/g, ' ')}` }) }
    } else if(userStage == 'Coin Size Patch'){
        if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `Coin Size Patches`; }) }
    }else {
      if(typeOfLoss.length != 0) { typeOfLoss.forEach((stage) => { stage.innerHTML = `${data.Type_of_hair_loss}`; }) }
    }
  }
  /* Dandruff Response */
  var dandruffResp = response.User_Analysis.dandruff_response;
  
  if(userStage != 'Stage-6') {
    if(dandruffResp == 'Yes, heavy dandruff that sticks to the scalp') {
      let stageElement = document.querySelector('.male_pcos_causing_main');
      if(stageElement){
        document.querySelector('.male_pcos_causing_main').style.display = 'block';
      }
    }
  }

  /* 3 Sections on All Stages Except Stage6 & Coin Size Patch Changes */
  if(userStage == 'Stage-6') {
      let stage6plan = document.querySelector('.male-treatment-plan');
      let stage6plan2 = document.querySelector('.aldrich-faq');
      if(stage6plan && stage6plan2){
        document.querySelector('.male-treatment-plan').style.display = 'none';
        document.querySelector('.aldrich-faq').style.display = 'none';
      }
    }
  
  if(userStage != 'Stage-6') {
    let userStage6plan = document.querySelector('.stage1-doctors');
    if(userStage6plan){
      document.querySelector('.stage1-doctors').style.display = 'block';
    }
  }
  
  selectedStage = data.stage;
  document.querySelector(`.${selectedStage}`)?.classList.add('selectedStage');
  if (selectedStage === 'Stage-1') {
    // document.querySelector('.Stage-1')?.classList.add('all-stages');
    // document.querySelector('.main-stage-section')?.classList.add('all-stages-pd');
  } else if (selectedStage === 'Stage-2') {
    document.querySelector('.Stage-2-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-3') {
    document.querySelector('.Stage-3-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-4') {
    document.querySelector('.Stage-4-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-5') {
    document.querySelector('.Stage-5-1')?.classList.add('checkStage');
  } else if (selectedStage === 'Stage-6') {
    document.querySelector('.Stage-5')?.classList.add('checkStage');
  } else if (selectedStage === 'Coin Size Patch') {
    document.querySelector('.Stage-7')?.classList.add('selectedStage');
  } else if (selectedStage === 'Heavy Hair Fall Across The Head' || selectedStage === "Heavy Hair Fall") {
    document.querySelector('#male-stages')?.classList.add('male-stagesTE');
    document.querySelector('.TE_stage-name').style.display = "none";
    document.querySelector('#stageDescription')?.classList.add('stageDescriptionTE');
    document.querySelector('.Stage-8')?.classList.add('selectedStage');
    document.querySelector('.Stage-8-1')?.classList.add('checkStage', 'hide-text');
  }
  var __selectedStage = document.querySelectorAll(".selectedStage");
  if(__selectedStage.length) {
    __selectedStage.forEach((stage) => {
      var imageField = stage.querySelector("img");
      if(imageField && stageImage) imageField.setAttribute("src", stageImage);
    })
  }
  var diagnoses__image =  document.querySelector('.diagnoses-result > img');
  if(diagnoses__image) { diagnoses__image.style.display = 'none'; }
  if(ourdia) {
    var ourdia__li = ourdia.querySelectorAll('li');
    ourdia__li.forEach((li) => {
      li.style.display = 'none';
    });
    var ourdia__btns = ourdia.querySelectorAll('a');
    if(ourdia__btns.length != 0) {
      ourdia__btns.forEach((btns) => {
        btns.addEventListener('click', function(e) {
          e.preventDefault();
          var id = this.getAttribute('data-id'), tab_panes = document.querySelectorAll('.tab-pane'),
          nav__links = document.querySelectorAll('.nav-item.nav-link');
          tab_panes.forEach((pane) => {
            pane.classList.remove('active');
            pane.classList.remove('show');
          });
          document.querySelector(`#nav-tabContent #${id}`).classList.add('active');
          document.querySelector(`#nav-tabContent #${id}`).classList.add('show');
          nav__links.forEach((links) => {
            links.classList.remove('active');
          });
          document.querySelector(`#nav-tab #${id}-tab`).classList.add('active');
        });
      });
    }
  }
  if(stagesnames.length) {showOrHide(stagesnames, "none");}
  var __selectedStage = document.querySelectorAll(".selectedStage");
  if(__selectedStage.length) {
    __selectedStage.forEach((stage) => {
      var imageField = stage.querySelector("img");
      if(imageField && stageImage) imageField.setAttribute("src", stageImage);
    })
  }
  var atcButtonRP4 = document.querySelectorAll('#add-to-cart-result-page'),
  stickyAtcButtonRP4 =  document.querySelectorAll('.sticky-btn #add-to-cart-result-page');
  if(atcButtonRP4.length != 0) {
    atcButtonRP4.forEach((btn) => {
      btn.setAttribute('user-mobile', data.phone);
      btn.setAttribute('user-email', data.email);
    });
  }
  if(stickyAtcButtonRP4.length != 0) {
    stickyAtcButtonRP4.forEach((btn) => {
      btn.setAttribute('user-mobile', data.phone);
      btn.setAttribute('user-email', data.email);
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const listItems = document.querySelectorAll(".f-b-main-li");
  const anchorLinks = document.querySelectorAll(".nav-link");
  const tabLinks = document.querySelectorAll(".tab-pane");

  /* By Default, Click First Root Cause on Stage Modal */
  // const clickButton = document.getElementById("learn_more");

  // clickButton.addEventListener("click", function() {
  //   const firstFlexDiv = document.querySelector(".nav-item[style*='display: flex;']");
  //   if(firstFlexDiv) {
  //     firstFlexDiv.click();
  //   }
  // });
  /* By Default, Click First Root Cause on Stage Modal */
  
  listItems.forEach(function (item) {
    item.addEventListener("click", function () {
      const target = this.getAttribute("data-targets");
      triggerAction(target);
    });
  });

  function triggerAction(target) {
    anchorLinks.forEach(function (link) {
      if (link.getAttribute("data-targets") === target) {
        anchorLinks.forEach(function (link) {
          link.classList.remove("active");
        });
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });

    tabLinks.forEach(function (tab) {
      if (tab.getAttribute("data-targets") === target) {
        tabLinks.forEach(function (tab) {
          tab.classList.remove("active");
          tab.classList.remove("show");
        });
        tab.classList.add("active");
        tab.classList.add("show");
      } else {
        tab.classList.remove("active");
        tab.classList.remove("show");
      }
    });
  }
});

function cartData() {
  window.dataLayer = window.dataLayer || [];
  function gtag(){
    dataLayer.push(arguments);
  }
  fetch("/cart.js").then((cart) => {
    return cart.json();
  }).then((cart) => {
    var items = [];
    cart.items.forEach((item) => {
      items.push({
        "item_id": item.id,
        "item_name": item.title,
        "item_brand": "Traya Health",
        "item_category": "",
        "price": (parseInt(item.price) / 100),
        "quantity": item.quantity
      })
    });
    var eventData = {
      "currency": cart.currency,
      "value": (parseInt(cart.items_subtotal_price) / 100),
      "items": items
    };
    gtag('js', new Date());
    gtag('config', 'G-KJK84KP0LJ');
    gtag("event", "view_cart", eventData);
    Shopify.analytics.publish("add_to_cart_mrp", {
      event: "add_to_cart_mrp"
    });
  }).catch((error) => {
    console.error("Error: ", error);
  })
}
function showOrHide(partition, state) {
  partition.forEach((part) => {
    part.style.display = `${state}`;
  })
}